
<script>
import Form from './form.vue'
import BadResult from './bad-result.vue'
import GoodResult from './good-result.vue'
import FinalResult from './final-result.vue'
import Button from './button.vue'
import { getCompetitionDetail, getCompetitionInfo } from '@/services/result'
// import './rep-data'
// import './pre-data'

export default {
  components: {
    Form,
    Button,
    BadResult,
    GoodResult,
    FinalResult
  },
  data () {
    return {
      type: 1, // 1 初赛 2 复赛
      currentComponent: 'Form',
      // title: '查询初赛结果',
      resultData: [],
      currentItem: null,
      info: { // 竞赛基础信息
        1: [ // 初赛信息
          {
            time: '2024年1月5日-1月20日',
            nextTime: "2024年5月12日",
            prepareTime: "2024年5月7日-11日 23:59",
            group: [
              '小学低年级组：13:00-14:00', '小学高年级组：15:00 - 16:00', '初中组：10:00 - 11:00'
            ]
          },
          {
            time: '2024年1月21日-4月15日',
            nextTime: "2024年5月12日",
            prepareTime: "2024年5月7日-11日 23:59",
            group: [
              '小学低年级组：13:00-14:00', '小学高年级组：15:00 - 16:00', '初中组：10:00 - 11:00'
            ]
          }
        ],
        2: [ // 复赛信息
          {
            time: '2024年1月28日',
            prepareTime: '2024年1月24-26日',
          },
          {
            time: '2024年5-6月',
            prepareTime: '待定',
          }
        ]
      }
    }
  },
  computed: {
    title() {
      let result = this.type === 2 ? '查询复赛结果' : '查询初赛结果'
      if (this.currentComponent === 'GoodResult' || this.currentComponent === 'BadResult') {
        result = '查询初赛结果'
      } else if (this.currentComponent === 'FinalResult') {
        result = '复赛占比'
      }
      return result
    },
    currentInfo() {
      if (this.currentItem) {
        return this.info[this.type][+this.currentItem[1] - 1]
      }
      return {}
    }
  },
  mounted () {
    if (this.$route.query.t === 'final') {
      this.type = 2
    }
    this.getBaseInfo()
    // this.getResult()
    // this.currentComponent = 'GoodResult'
  },
  watch: {
    // resultData (val) {
    //   // console.log('======', val)
    // },
  },
  methods: {
    // decodeCode (code) {
    //   code = decodeURIComponent(escape(window.atob(code)))
    //   return Array.from(code).map(char => String.fromCharCode(char.charCodeAt(0) - 3)).join('')
    // },
    formSubmit ({ groupName, userName}) {
      this.getItemResult(groupName, userName).then(res => {
        if (res.status === 200 && res.data) {
          const { name, score, status, team, language, group, session } = res.data
          // ["组别", "场次", "语言", "姓名", "团队名称", "晋级状态"]
          if (this.type === 1) {
            this.currentItem = [ group, session, language, name, team, status === '是' ? '1' : '0' ]
          } else {
            this.currentItem = [group, session, language, name, team, score * 100]
          }
          if (this.type === 2) {
            this.currentComponent = 'FinalResult'
          } else if (this.currentItem[5] === '1') {
            this.currentComponent = 'GoodResult'
          } else if (this.currentItem[5] === '0') {
            this.currentComponent = 'BadResult'
          }
        } else {
          this.$message.showMessage({ info: '未查询到该学员的竞赛结果' });
        }
      }).catch(() => {
        // console.log(err)
        this.$message.showMessage({ info: '未查询到该学员的竞赛结果' });
      })
    },
    // getResult() {
    //   try {
    //     if (this.type === 2) {
    //       getCompetitionRepList().then(res => {
    //         this.resultData = JSON.parse(this.decodeCode(res.data))
    //       })
    //     } else {
    //       getCompetitionPreList().then(res => {
    //         this.resultData = JSON.parse(this.decodeCode(res.data))
    //       })
    //     }
    //   } catch (error) {
    //     // console.log(error)
    //   }
    // },
    getBaseInfo() {
      try {
        getCompetitionInfo().then(res => {
          this.info = res.data
        })
      } catch (error) {
        // console.log(error)
      }
    },
    getItemResult(groupName, userName) {
      return getCompetitionDetail({ name: userName, team: groupName, round: this.type})
      // this.currentItem = this.resultData.filter(item => item[4] === groupName && item[3] === userName)[0]
    }
  }
}
</script>
<template>
  <div class="result-page">
    <div class="result-banner">
      <img class="result-image" src="@/assets/result/banner-js.png" alt="banner">
    </div>
    <component :is="currentComponent" :title="title" @submit="formSubmit" :data="currentItem" :info="currentInfo"/>
    <div v-if="currentComponent != 'Form'" class="result-button" :class="[{'result-button-bad': currentComponent === 'BadResult'}]"><Button type="border"
        @click="currentComponent = 'Form'">返回</Button></div>
  </div>
</template>
<style lang="less" scoped>
.result-page {
  width: 100%;
  min-height: 100%;
  min-width: 1440px;
  background: #0052d0;
}
.result-banner {
  width: 100%;
  .result-image {
    width: 100%;
  }
}
.result-button {
  width: 405px;
  margin: 0 auto;
  margin-top: -110px;
  padding-bottom: 67px;
  position: relative;
  z-index: 1;
  &-bad {
    margin-top: -180px;
  }
}
</style>